<template>
    <div class="bg-primary relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot-login">

        <div class="flex flex-1 flex-row">
            <div class="flex items-start w-1/3">
                <img :src="getImage('logo')" class="fixed w-1/4 m-24">
            </div>

            <div class="flex items-center justify-center w-2/3">
                <div class="bg-white rounded-xl p-12 w-3/5 papsi-container-login">
                    <LabelControl type="heading" content="ENTER KIOSK PIN"></LabelControl>
                    <KeypadControl input_type="PIN" @digits-full="login" />
                </div>
            </div>
        </div>

        <div class="h-24 bg-secondary flex items-center justify-end pr-10">
            <DateTimeControl />
        </div>
    </div>
</template>

<script>
import LabelControl from "@/components/controls/LabelControl.vue";
import KeypadControl from "@/components/controls/KeypadControl.vue";
import DateTimeControl from "@/components/controls/DateTimeControl.vue";
import kiosk from "@/services/kiosk";
import mixin from "@/mixins/controls.js";

export default {
    mixins: [mixin],
    components: {
        LabelControl,
        KeypadControl,
        DateTimeControl
    },
    inject: ['setLoading', 'setError'],
    mounted() {
        this.$emit('checkauth', false);
    },
    methods: {
        typing(object) {
            this[object.name] = object.value;
        },
        login(PIN) {

            const pin_string = PIN.join('');
            const device_id = new URLSearchParams(window.location.search).get('device_id');

            this.setLoading(true);

            kiosk.createSession(device_id, pin_string)
                .then((response) => {
                    const branch_state = this.$store.state.branch;
                    const data = response.data.data;

                    branch_state.branch_abbr = data.branch_abbr;
                    branch_state.branch_code = data.branch_code;
                    branch_state.branch_name = data.branch_name;
                    branch_state.kiosk_id = data.kiosk_id;
                    branch_state.session_id = data.session_id;
                    branch_state.device_id = device_id;

                    this.makeCookies(branch_state);
                    kiosk.setSessionID(branch_state.session_id);
                    this.$router.push({ name: 'start-page', query: { device_id: branch_state.device_id } });
                })
                .catch((error) => {
                    this.showError(error.response.data.message);
                })
                .finally(() => {
                    this.setLoading(false);
                });
        },
        makeCookies(branch_state) {
            this.$cookies.set('session_id', branch_state.session_id);
            this.$cookies.set('branch_abbr', branch_state.branch_abbr);
            this.$cookies.set('branch_code', branch_state.branch_code);
            this.$cookies.set('branch_name', branch_state.branch_name);
            this.$cookies.set('kiosk_id', branch_state.kiosk_id);
        }
    },
};
</script>

<style scoped>
.papsi-mascot-login {
    bottom: 0;
    left: 0;
    width: 45rem;
}

@media only screen and (min-width: 2500px) {
    .papsi-mascot-login {
    bottom: 0;
    left: 0;
    width: 60rem;
    }

    .papsi-container-login {
        width: 80rem;
        height: 60rem;
    }
    
}

</style>
